import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=45d1f56c&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45d1f56c')) {
      api.createRecord('45d1f56c', component.options)
    } else {
      api.reload('45d1f56c', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=45d1f56c&", function () {
      api.rerender('45d1f56c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-27JJw5TlM5gwZ/JS/offershelp.vue"
export default component.exports